import React from 'react'
import Seo from './common/Seo';
import Hero from './introduction/Hero';
import CompanyOverview from './introduction/CompanyOverview';
import OrgChart from './introduction/OrgChart';
import HistoryTimeline from './introduction/HistoryTimeline';
import Certifications from './introduction/Certifications';

const Introduction = () => {
    return (
        <>
            <Seo
              title="회사소개"
              description="엠티에스티(MTST)의 비전과 연혁, 조직, 인증 현황을 소개합니다. 스마트 제조 생태계의 글로벌 리더를 지향합니다."
              path="/introduction"
            />
            <Hero/>
            <CompanyOverview/>
            <OrgChart/>
            <HistoryTimeline/>
            <Certifications/>
        </>
    );
}

export default Introduction
